import { render, staticRenderFns } from "./highlightable.vue?vue&type=template&id=363f4a1a&scoped=true&"
import script from "./highlightable.vue?vue&type=script&lang=ts&"
export * from "./highlightable.vue?vue&type=script&lang=ts&"
import style0 from "./highlightable.vue?vue&type=style&index=0&id=363f4a1a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363f4a1a",
  null
  
)

export default component.exports